
document.addEventListener("DOMContentLoaded", () => {
    const blocks = document.querySelectorAll('[data-type="image-and-text"]');

    blocks.forEach((block, index) => {
        const prev = block.previousElementSibling;
        const next = block.nextElementSibling;

        const prevIsSame = prev?.dataset?.type === "image-and-text";
        const nextIsSame = next?.dataset?.type === "image-and-text";

        if (prevIsSame && nextIsSame) {
            // no extra padding needed
            return;
        }

        if (prevIsSame) {
            block.classList.add("lg:pb-[var(--spacing-40)]");
            block.classList.add("pb-[var(--spacing-24)]");
            return;
        }

        if (nextIsSame) {
            block.classList.add("lg:pt-[var(--spacing-40)]");
            block.classList.add("pt-[var(--spacing-24)]");
            return;
        }

        block.classList.add("lg:py-[var(--spacing-40)]");
        block.classList.add("py-[var(--spacing-24)]");
    });
});
